module.exports = __webpack_public_path__ + "static/media/44.4447dbff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/44.jpg
// module id = 734
// module chunks = 0